import {$} from '../jquery-definition.js';

$( function() {
	var $checkboxContainer = $( '.checkbox-max' );

	$checkboxContainer.each( function() {
		var $this = $( this );
		var $checkboxes = $this.find( 'input[type="checkbox"]' );
		var max = $this.attr( 'data-max' );

		$checkboxes.change( function() {
			var current = $checkboxes.filter( ':checked' ).length;
			$checkboxes.filter( ':not(:checked)' ).prop( 'disabled', current >= max );
		} );
	} );

	$( '.wpcf7' ).on( 'click', function( clickEvent ) {
		var $this = $( this );

		$this.find( '.wpcf7-recaptcha' ).addClass( 'active' );
	} );
} );
